import { render, staticRenderFns } from "./Post_Broadcast_Component.vue?vue&type=template&id=d0484854&scoped=true"
import script from "./Post_Broadcast_Component.vue?vue&type=script&lang=js"
export * from "./Post_Broadcast_Component.vue?vue&type=script&lang=js"
import style0 from "./Post_Broadcast_Component.vue?vue&type=style&index=0&id=d0484854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0484854",
  null
  
)

export default component.exports